import { computed, type ComputedRef, type Ref } from 'vue'

import { serverErrorMessage } from '@/shared/api'

/**
 * The sentence an edit form shows **instead of itself** when the record it is editing could
 * not be read — pass it straight to `FormModal`'s `loadError`, from the detail query's
 * `isError` and `error`.
 *
 * Wire it on every edit modal. Without it a failed detail query is indistinguishable from a
 * finished one: the seed fills nothing, loading goes false, and the form renders its own
 * defaults with Save enabled — so the next click PATCHes those defaults over a record
 * nobody ever read.
 */
export function recordLoadError(
  isError: Ref<boolean>,
  error: Ref<unknown>,
  fallback = 'Could not load the record.'
): ComputedRef<string | undefined> {
  return computed(() =>
    isError.value ? serverErrorMessage(error.value, fallback) : undefined
  )
}
